import { z } from "zod";

export const communityMembershipStatusEnum = z.enum([
  "PENDING",
  "JOINED",
  "NOT_JOINED",
]);

export type CommunityMembershipStatus = z.infer<
  typeof communityMembershipStatusEnum
>;

export const communityMemberSummarySchema = z.object({
  member_count: z.number(),
  network_member_count: z.number(),
  image_urls: z.array(z.string()),
  is_member: z.boolean(),
  membership_status: communityMembershipStatusEnum.nullable().optional(),
});

export type CommunityMemberSummary = z.infer<
  typeof communityMemberSummarySchema
>;
